const GET_TAHUNCONFIG_START = "GET_TAHUNCONFIG_START"
const GET_TAHUNCONFIG_SUCCESS = "GET_TAHUNCONFIG_SUCCESS"
const GET_TAHUNCONFIG_FAILED = "GET_TAHUNCONFIG_FAILED"

export {
    GET_TAHUNCONFIG_START,
    GET_TAHUNCONFIG_SUCCESS,
    GET_TAHUNCONFIG_FAILED
}